import { useEffect } from "react";

const DEFAULT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/2054b393-1ed0-4fab-a6dc-066b0e14038f/images/e929520287c42fe228a60ddf9ee7c13ee1fe397c1401e79ae246ee37e3a2989b.jpeg";

export default function Seo({ title, description, jsonLd, image }) {
  useEffect(() => {
    const full = title ? `${title} · Editorial Harvest` : "Editorial Harvest · Donde comienza la excelencia";
    document.title = full;
    const desc = description || "Editorial internacional de literatura cristiana y obras con propósito.";
    const img = image || DEFAULT_IMG;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", desc);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "Editorial Harvest");
    setMeta("property", "og:url", window.location.href);
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);

    let ld = document.getElementById("hv-jsonld");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "hv-jsonld";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, jsonLd, image]);

  return null;
}
